import React from "react"

import {
  AppIcons,
  AppText,
  Box,
  Divider,
  IconButton,
  Pressable,
  Row,
} from "@/theme"
import { renderIconFromIconProp } from "@/theme/icons/renderIconFromIconProp"

import type { IconButtonProps, IconProp } from "@/theme"
import type { SortDirectionKey } from "@/base/Sorting"

export function SortDirectionIconButton(
  props: Omit<IconButtonProps, "IconComponent" | "onPress"> & {
    currentDirection: SortDirectionKey
    isInverted?: boolean
    onPress: () => unknown
  },
): React.JSX.Element {
  const value = props.currentDirection

  let iconName: IconProp = "ArrowDown"
  if (value === "asc") {
    iconName = "ArrowUp"
  }
  if (props.isInverted === true) {
    iconName = "ArrowUp"
    if (value === "asc") {
      iconName = "ArrowDown"
    }
  }
  return (
    <IconButton
      size={"sm"}
      variant={"text"}
      {...props}
      IconComponent={iconName}
    />
  )
}

interface SortListItemProps {
  IconComponent?: IconProp
  isSelected: boolean
  onPress: () => void
  showDivider: boolean
  sortDirection: SortDirectionKey
  text: string
}

export function SortListItem({
  IconComponent,
  isSelected,
  onPress,
  showDivider,
  sortDirection,
  text,
}: SortListItemProps) {
  const directionIconElement =
    sortDirection === "asc" ? (
      <AppIcons.SortAscending />
    ) : (
      <AppIcons.SortDescending />
    )
  return (
    <React.Fragment>
      <Pressable trackHover trackPress onPress={onPress}>
        <Row flexWrap={"nowrap"} my={"$4"}>
          {renderIconFromIconProp(IconComponent)}
          <Box mx={"$2"}>
            <AppText>{text}</AppText>
          </Box>
          {isSelected ? directionIconElement : null}
        </Row>
      </Pressable>
      {showDivider ? <Divider /> : null}
    </React.Fragment>
  )
}
